module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_5.ec7792e8.png";